module.exports = __webpack_public_path__ + "static/fonts/CoTextCorp-Regular.9d4e00e.eot";